"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_MOBIKWIK_CHECKSUM_EVENT = exports.GET_PAYMENT_CONFIG_EVENT = exports.CHECK_FOR_UPDATE_EVENT = exports.CLEAR_ALL_NOTIFICATIONS_EVENT = exports.CLEAR_NOTIFICATION_EVENT = exports.VERIFY_OTP_EVENT = exports.REQUEST_OTP_EVENT = exports.GET_REFERRAL_POLICY_EVENT = exports.REDEEM_REFERRAL_CODE_EVENT = exports.PWF_VERIFY_TABLE_CREATIONS_DETAILS_EVENT = exports.PWF_VERIFY_SHARE_CODE_EVENT = exports.PWF_GET_PAYOUT_DISTRIBUTION_EVENT = exports.PWF_FIND_TABLE_AND_JOIN_EVENT = exports.PWF_CREATE_TABLE_EVENT = exports.WITHDRAW_COINS_EVENT = exports.SUBMIT_BANK_DETAILS_EVENT = exports.SUBMIT_KYC_EVENT = exports.GET_CASHFREE_TOKEN_EVENT = exports.VALIDATE_COUPON_EVENT = exports.GET_COUPONS_EVENT = exports.CHECK_PAYMENT_AVAILABILITY_EVENT = exports.WITHDRAW_COINS = exports.GET_WALLET_BALANCE_EVENT = exports.GET_COINS_INFO_EVENT = exports.GET_PASSBOOK_EVENT = exports.LANGUAGE_SELECTION_POSITION = exports.ENVIRONMENT = exports.COUPON_TYPE = exports.CODE_TYPE = exports.WIDGET_LABEL = exports.WIDGET_TYPES = exports.MAINTENANCE_STATUS = exports.SERVER_STATUS = exports.APP_LANGUAGE = exports.PLAYING_STATUS = exports.SERVER_TYPES = exports.RANK = exports.PLAYERS_COUNT = exports.REGISTRATION_STATUS = exports.POPUP_CTA_VALUES = exports.POPUP_CTA_TYPE = exports.SOCKET_TYPE = exports.RUPEES_TO_COINS_MULTIPLIER = exports.NOTIFICATION_TYPE = exports.SMSProviders = exports.DEVICE_TYPES = exports.TOURNAMENT_SEGMENT_INSTRUCTION = exports.GAME_NAME = exports.ERROR_NAME = exports.APP_NAME = void 0;
exports.MARKETING_DASHBOARD_CSV_TYPES = exports.INTERNAL_DASHBOARDS = exports.consumerType = exports.SIGN_IN_SIGN_UP = exports.liveGamesFields = exports.USER_INVERSE_AGGREGATION_KEY = exports.TOURNAMENT_NOT_JOINABLE_REASONS = exports.USER_AGGREGATION_KEY = exports.SMS_PROCESSING_TYPE = exports.SMS_PROVIDER = exports.GET_HELPDESK_TRANSACTIONS_EVENT_V2 = exports.LIST_HELPDESK_TOPICS_TICKETS_EVENT = exports.GET_CHECKOUT_META_CONFIGS_EVENT = exports.NUDGE_INDICATOR_EVENT = exports.GENERIC_POPUP_EVENT = exports.UPLOAD_HELPDESK_ATTACHMENT_EVENT = exports.ADD_HELPDESK_TICKET_COMMENT_EVENT = exports.LIST_HELPDESK_TICKETS_EVENT = exports.GET_HELPDESK_TICKET_EVENT = exports.CREATE_NEW_HELPDESK_TICKET_EVENT = exports.GET_HELPDESK_TRANSACTIONS_EVENT = exports.GET_HELPDESK_TOPICS_EVENT = exports.ACCEPT_TNC_EVENT = exports.GET_PAYTM_TXN_TOKEN_EVENT = exports.GET_USER_DETAILS_EVENT = exports.SET_USER_ADDRESS_EVENT = exports.GET_BANNERS_EVENT = exports.GET_TOURNAMENT_FILTERS_EVENT = exports.CHANGE_LANGUAGE_PREFERENCE_EVENT = exports.GET_HELP_TOPICS_EVENT = exports.WALKTHROUGH_COMPLETED_EVENT = void 0;
var APP_NAME;
(function (APP_NAME) {
    APP_NAME["LUDO"] = "ludo";
    APP_NAME["NINJA"] = "ninja";
    APP_NAME["SNL"] = "snl";
})(APP_NAME = exports.APP_NAME || (exports.APP_NAME = {}));
var ERROR_NAME;
(function (ERROR_NAME) {
    ERROR_NAME["VALIDATION_ERROR"] = "ValidationError";
})(ERROR_NAME = exports.ERROR_NAME || (exports.ERROR_NAME = {}));
var GAME_NAME;
(function (GAME_NAME) {
    GAME_NAME["LUDO"] = "ludo";
    GAME_NAME["NINJA"] = "ninja";
    GAME_NAME["SNL"] = "snl";
    GAME_NAME["TURBO"] = "turbo";
    GAME_NAME["SUPER"] = "super";
    GAME_NAME["SNLT"] = "snlt";
})(GAME_NAME = exports.GAME_NAME || (exports.GAME_NAME = {}));
var TOURNAMENT_SEGMENT_INSTRUCTION;
(function (TOURNAMENT_SEGMENT_INSTRUCTION) {
    TOURNAMENT_SEGMENT_INSTRUCTION["INCLUDE"] = "INCLUDE";
    TOURNAMENT_SEGMENT_INSTRUCTION["EXCLUDE"] = "EXCLUDE";
})(TOURNAMENT_SEGMENT_INSTRUCTION = exports.TOURNAMENT_SEGMENT_INSTRUCTION || (exports.TOURNAMENT_SEGMENT_INSTRUCTION = {}));
var DEVICE_TYPES;
(function (DEVICE_TYPES) {
    DEVICE_TYPES["ANDROID"] = "android";
    DEVICE_TYPES["IOS"] = "ios";
    DEVICE_TYPES["WEB"] = "web";
})(DEVICE_TYPES = exports.DEVICE_TYPES || (exports.DEVICE_TYPES = {}));
var SMSProviders;
(function (SMSProviders) {
    SMSProviders["MSG91_TRANSACTIONAL"] = "MSG91_TRANSACTIONAL";
    SMSProviders["TEXTLOCAL"] = "TEXTLOCAL";
    SMSProviders["VALUEFIRST"] = "VALUEFIRST";
    SMSProviders["MSG91_OTP"] = "MSG91_OTP";
    SMSProviders["TWOFACTOR"] = "TWOFACTOR";
    SMSProviders["GUPSHUP"] = "GUPSHUP";
    SMSProviders["SNS"] = "SNS";
})(SMSProviders = exports.SMSProviders || (exports.SMSProviders = {}));
var NOTIFICATION_TYPE;
(function (NOTIFICATION_TYPE) {
    NOTIFICATION_TYPE["REFERRAL_CODE_REDEMPTION_REFERRER"] = "REFERRAL_CODE_REDEMPTION_REFERRER";
    NOTIFICATION_TYPE["SIGNUP_BONUS"] = "SIGNUP_BONUS";
    NOTIFICATION_TYPE["TOURNAMENT_STARTING"] = "TOURNAMENT_STARTING";
    NOTIFICATION_TYPE["TOURNAMENT_REFUND"] = "TOURNAMENT_REFUND";
    NOTIFICATION_TYPE["WINNING_CASH"] = "WINNING_CASH";
    NOTIFICATION_TYPE["WINNING_BONUS"] = "WINNING_BONUS";
    NOTIFICATION_TYPE["TOURNAMENT_PLAYING_ON_DIFFRENT_TABLE"] = "TOURNAMENT_PLAYING_ON_DIFFRENT_TABLE";
    NOTIFICATION_TYPE["REFERRAL_CODE_REDEMPTION_REFEREE"] = "REFERRAL_CODE_REDEMPTION_REFEREE";
    NOTIFICATION_TYPE["PAYMENT_COMPLETE"] = "PAYMENT_COMPLETE";
    NOTIFICATION_TYPE["WHATSAPP_UPLOAD_VERIFIED"] = "WHATSAPP_UPLOAD_VERIFIED";
    NOTIFICATION_TYPE["WHATSAPP_UPLOAD_INVALID"] = "WHATSAPP_UPLOAD_INVALID";
    NOTIFICATION_TYPE["WHATSAPP_CHALLENGE_COMPLETED"] = "WHATSAPP_CHALLENGE_COMPLETED";
    NOTIFICATION_TYPE["REFERRAL_SUCCESS_REFERRER"] = "REFERRAL_SUCCESS_REFERRER";
    NOTIFICATION_TYPE["KYC_ERROR"] = "KYC_ERROR";
    NOTIFICATION_TYPE["INVALID_UPI_ID"] = "INVALID_UPI_ID";
    NOTIFICATION_TYPE["CREDIT_COINS_BY_ADMIN"] = "CREDIT_COINS_BY_ADMIN";
    NOTIFICATION_TYPE["INVALID_BANK"] = "INVALID_BANK";
    NOTIFICATION_TYPE["KYC_APPROVED"] = "KYC_APPROVED";
    NOTIFICATION_TYPE["REMOVE_PP"] = "PROFILE_PICTURE_REMOVED";
    NOTIFICATION_TYPE["BANK_VALIDATION_UPDATE"] = "BANK_VALIDATION_UPDATE";
})(NOTIFICATION_TYPE = exports.NOTIFICATION_TYPE || (exports.NOTIFICATION_TYPE = {}));
/*
    CG_EXP_BUCKET::
        Variant 1 (bucket name = "test1"):
                - CGP Tournaments: none should be visible
                - Normal Tournaments: all visible, but Experimentable tournaments should be pinned on top
        Variant 2 (bucket name = "test2")
                - CGP Tournaments: only Experimentable tournaments visible
                - Normal tournaments: visible but excluding Experimentable tournaments
             */
exports.RUPEES_TO_COINS_MULTIPLIER = 100;
var SOCKET_TYPE;
(function (SOCKET_TYPE) {
    SOCKET_TYPE["GAMEPLAY_CLIENT"] = "GAMEPLAY_CLIENT";
    SOCKET_TYPE["MAIN_CLIENT"] = "MAIN_CLIENT";
    SOCKET_TYPE["COMMON_CLIENT"] = "COMMON_CLIENT";
})(SOCKET_TYPE = exports.SOCKET_TYPE || (exports.SOCKET_TYPE = {}));
var POPUP_CTA_TYPE;
(function (POPUP_CTA_TYPE) {
    POPUP_CTA_TYPE["IN_APP"] = "IN_APP";
})(POPUP_CTA_TYPE = exports.POPUP_CTA_TYPE || (exports.POPUP_CTA_TYPE = {}));
var POPUP_CTA_VALUES;
(function (POPUP_CTA_VALUES) {
    POPUP_CTA_VALUES["APP_RESTART"] = "APP_RESTART";
})(POPUP_CTA_VALUES = exports.POPUP_CTA_VALUES || (exports.POPUP_CTA_VALUES = {}));
var REGISTRATION_STATUS;
(function (REGISTRATION_STATUS) {
    REGISTRATION_STATUS["REGISTERED"] = "REGISTERED";
    REGISTRATION_STATUS["SKIPPED_ON_OFFLINE"] = "SKIPPED_ON_OFFLINE";
    REGISTRATION_STATUS["PLAYING_ON_DIFFERENT_TABLE"] = "PLAYING_ON_DIFFERENT_TABLE";
    REGISTRATION_STATUS["TABLE_ASSIGNED"] = "TABLE_ASSIGNED";
    REGISTRATION_STATUS["TABLE_NOT_ASSIGNED"] = "TABLE_NOT_ASSIGNED";
    REGISTRATION_STATUS["UNREGISTERED"] = "UNREGISTERED";
    REGISTRATION_STATUS["TABLE_JOINED"] = "TABLE_JOINED";
    REGISTRATION_STATUS["TABLE_SYSTEM_JOINED"] = "TABLE_SYSTEM_JOINED";
    REGISTRATION_STATUS["TABLE_LEFT"] = "TABLE_LEFT";
    REGISTRATION_STATUS["EXIT_MATCHING"] = "EXIT_MATCHING";
    REGISTRATION_STATUS["SYSTEM_EXIT_MATCHING"] = "SYSTEM_EXIT_MATCHING";
    REGISTRATION_STATUS["TABLE_FINISHED"] = "TABLE_FINISHED";
})(REGISTRATION_STATUS = exports.REGISTRATION_STATUS || (exports.REGISTRATION_STATUS = {}));
var PLAYERS_COUNT;
(function (PLAYERS_COUNT) {
    PLAYERS_COUNT[PLAYERS_COUNT["ONE"] = 1] = "ONE";
    PLAYERS_COUNT[PLAYERS_COUNT["TWO"] = 2] = "TWO";
    PLAYERS_COUNT[PLAYERS_COUNT["THREE"] = 3] = "THREE";
    PLAYERS_COUNT[PLAYERS_COUNT["FOUR"] = 4] = "FOUR";
})(PLAYERS_COUNT = exports.PLAYERS_COUNT || (exports.PLAYERS_COUNT = {}));
var RANK;
(function (RANK) {
    RANK[RANK["FIRST"] = 1] = "FIRST";
    RANK[RANK["SECOND"] = 2] = "SECOND";
    RANK[RANK["THIRD"] = 3] = "THIRD";
    RANK[RANK["FOURTH"] = 4] = "FOURTH";
})(RANK = exports.RANK || (exports.RANK = {}));
var SERVER_TYPES;
(function (SERVER_TYPES) {
    SERVER_TYPES["HTTP_SERVER"] = "httpServer";
    SERVER_TYPES["WS_SERVER"] = "wsServer";
    SERVER_TYPES["WORKER"] = "worker";
})(SERVER_TYPES = exports.SERVER_TYPES || (exports.SERVER_TYPES = {}));
var PLAYING_STATUS;
(function (PLAYING_STATUS) {
    PLAYING_STATUS[PLAYING_STATUS["PLAYING"] = 1] = "PLAYING";
    PLAYING_STATUS[PLAYING_STATUS["OFFLINE_USER"] = 2] = "OFFLINE_USER";
    PLAYING_STATUS[PLAYING_STATUS["ONLINE_USER"] = 3] = "ONLINE_USER";
})(PLAYING_STATUS = exports.PLAYING_STATUS || (exports.PLAYING_STATUS = {}));
var APP_LANGUAGE;
(function (APP_LANGUAGE) {
    APP_LANGUAGE["ENGLISH"] = "en";
    APP_LANGUAGE["HINDI"] = "hi";
    APP_LANGUAGE["MARATHI"] = "mr";
})(APP_LANGUAGE = exports.APP_LANGUAGE || (exports.APP_LANGUAGE = {}));
var SERVER_STATUS;
(function (SERVER_STATUS) {
    SERVER_STATUS["ACTIVE"] = "active";
    SERVER_STATUS["INACTIVE"] = "inactive";
})(SERVER_STATUS = exports.SERVER_STATUS || (exports.SERVER_STATUS = {}));
var MAINTENANCE_STATUS;
(function (MAINTENANCE_STATUS) {
    MAINTENANCE_STATUS["ON"] = "on";
    MAINTENANCE_STATUS["OFF"] = "off";
})(MAINTENANCE_STATUS = exports.MAINTENANCE_STATUS || (exports.MAINTENANCE_STATUS = {}));
var WIDGET_TYPES;
(function (WIDGET_TYPES) {
    WIDGET_TYPES["POP_UP"] = "POP_UP";
})(WIDGET_TYPES = exports.WIDGET_TYPES || (exports.WIDGET_TYPES = {}));
var WIDGET_LABEL;
(function (WIDGET_LABEL) {
    WIDGET_LABEL["GENERIC_IMAGE"] = "GENERIC_IMAGE";
})(WIDGET_LABEL = exports.WIDGET_LABEL || (exports.WIDGET_LABEL = {}));
var CODE_TYPE;
(function (CODE_TYPE) {
    CODE_TYPE["REFERRAL_CODE"] = "referralCode";
    CODE_TYPE["COUPON_CODE"] = "couponCode";
})(CODE_TYPE = exports.CODE_TYPE || (exports.CODE_TYPE = {}));
var COUPON_TYPE;
(function (COUPON_TYPE) {
    COUPON_TYPE["REGULAR"] = "REGULAR";
    COUPON_TYPE["EXCLUSIVE"] = "EXCLUSIVE";
    COUPON_TYPE["PARTNER_COUPON_CASHLESS"] = "PARTNER_COUPON_CASHLESS";
    COUPON_TYPE["PARTNER_COUPON_CASH"] = "PARTNER_COUPON_CASH";
})(COUPON_TYPE = exports.COUPON_TYPE || (exports.COUPON_TYPE = {}));
var ENVIRONMENT;
(function (ENVIRONMENT) {
    ENVIRONMENT["PRODUCTION"] = "production";
    ENVIRONMENT["DEVELOPMENT"] = "development";
})(ENVIRONMENT = exports.ENVIRONMENT || (exports.ENVIRONMENT = {}));
var LANGUAGE_SELECTION_POSITION;
(function (LANGUAGE_SELECTION_POSITION) {
    LANGUAGE_SELECTION_POSITION["TOP"] = "TOP";
    LANGUAGE_SELECTION_POSITION["BOTTOM"] = "BOTTOM";
    LANGUAGE_SELECTION_POSITION["NONE"] = "NONE";
})(LANGUAGE_SELECTION_POSITION = exports.LANGUAGE_SELECTION_POSITION || (exports.LANGUAGE_SELECTION_POSITION = {}));
exports.GET_PASSBOOK_EVENT = "GET_PASSBOOK";
exports.GET_COINS_INFO_EVENT = "GET_COINS_INFO";
exports.GET_WALLET_BALANCE_EVENT = "GET_WALLET_BALANCE";
exports.WITHDRAW_COINS = "WITHDRAW_COINS";
exports.CHECK_PAYMENT_AVAILABILITY_EVENT = "CHECK_PAYMENT_AVAILABILITY";
exports.GET_COUPONS_EVENT = "GET_COUPONS";
exports.VALIDATE_COUPON_EVENT = "VALIDATE_COUPON";
exports.GET_CASHFREE_TOKEN_EVENT = "GET_CASHFREE_TOKEN";
exports.SUBMIT_KYC_EVENT = "SUBMIT_KYC";
exports.SUBMIT_BANK_DETAILS_EVENT = "SUBMIT_BANK_DETAILS";
exports.WITHDRAW_COINS_EVENT = "WITHDRAW_COINS";
exports.PWF_CREATE_TABLE_EVENT = "CREATE_PWF_TABLE";
exports.PWF_FIND_TABLE_AND_JOIN_EVENT = "PWF_FIND_TABLE_AND_JOIN";
exports.PWF_GET_PAYOUT_DISTRIBUTION_EVENT = "PWF_GET_PAYOUT_DISTRIBUTION";
exports.PWF_VERIFY_SHARE_CODE_EVENT = "PWF_VERIFY_SHARE_CODE";
exports.PWF_VERIFY_TABLE_CREATIONS_DETAILS_EVENT = "PWF_VERIFY_TABLE_CREATIONS_DETAILS";
exports.REDEEM_REFERRAL_CODE_EVENT = "REDEEM_REFERRAL_CODE";
exports.GET_REFERRAL_POLICY_EVENT = "GET_REFERRAL_POLICY";
exports.REQUEST_OTP_EVENT = "REQUEST_OTP";
exports.VERIFY_OTP_EVENT = "VERIFY_OTP";
exports.CLEAR_NOTIFICATION_EVENT = "CLEAR_NOTIFICATION";
exports.CLEAR_ALL_NOTIFICATIONS_EVENT = "CLEAR_ALL_NOTIFICATIONS";
exports.CHECK_FOR_UPDATE_EVENT = "CHECK_FOR_UPDATE";
exports.GET_PAYMENT_CONFIG_EVENT = "GET_PAYMENT_CONFIG";
exports.GET_MOBIKWIK_CHECKSUM_EVENT = "GET_MOBIKWIK_CHECKSUM";
exports.WALKTHROUGH_COMPLETED_EVENT = "WALKTHROUGH_COMPLETED";
exports.GET_HELP_TOPICS_EVENT = "GET_HELP_TOPICS";
exports.CHANGE_LANGUAGE_PREFERENCE_EVENT = "CHANGE_LANGUAGE_PREFERENCE";
exports.GET_TOURNAMENT_FILTERS_EVENT = "GET_TOURNAMENT_FILTERS";
exports.GET_BANNERS_EVENT = "GET_BANNERS";
exports.SET_USER_ADDRESS_EVENT = "SET_USER_ADDRESS";
exports.GET_USER_DETAILS_EVENT = "GET_USER_DETAILS";
exports.GET_PAYTM_TXN_TOKEN_EVENT = "GET_PAYTM_TXN_TOKEN";
exports.ACCEPT_TNC_EVENT = "ACCEPT_TNC";
exports.GET_HELPDESK_TOPICS_EVENT = "GET_HELPDESK_TOPICS";
exports.GET_HELPDESK_TRANSACTIONS_EVENT = "GET_HELPDESK_TRANSACTIONS";
exports.CREATE_NEW_HELPDESK_TICKET_EVENT = "CREATE_NEW_HELPDESK_TICKET";
exports.GET_HELPDESK_TICKET_EVENT = "GET_HELPDESK_TICKET";
exports.LIST_HELPDESK_TICKETS_EVENT = "LIST_HELPDESK_TICKETS";
exports.ADD_HELPDESK_TICKET_COMMENT_EVENT = "ADD_HELPDESK_TICKET_COMMENT";
exports.UPLOAD_HELPDESK_ATTACHMENT_EVENT = "UPLOAD_HELPDESK_ATTACHMENT";
exports.GENERIC_POPUP_EVENT = "GENERIC_POPUP";
exports.NUDGE_INDICATOR_EVENT = "NUDGE_INDICATOR";
exports.GET_CHECKOUT_META_CONFIGS_EVENT = "GET_CHECKOUT_META_CONFIGS";
exports.LIST_HELPDESK_TOPICS_TICKETS_EVENT = "LIST_HELPDESK_TOPICS_TICKETS";
exports.GET_HELPDESK_TRANSACTIONS_EVENT_V2 = "GET_HELPDESK_TRANSACTIONS_v2";
var SMS_PROVIDER;
(function (SMS_PROVIDER) {
    SMS_PROVIDER["TIMES_INTERNET"] = "TIMES_INTERNET";
})(SMS_PROVIDER = exports.SMS_PROVIDER || (exports.SMS_PROVIDER = {}));
var SMS_PROCESSING_TYPE;
(function (SMS_PROCESSING_TYPE) {
    SMS_PROCESSING_TYPE["SINGLE"] = "SINGLE";
    SMS_PROCESSING_TYPE["BULK"] = "BULK";
})(SMS_PROCESSING_TYPE = exports.SMS_PROCESSING_TYPE || (exports.SMS_PROCESSING_TYPE = {}));
var USER_AGGREGATION_KEY;
(function (USER_AGGREGATION_KEY) {
    USER_AGGREGATION_KEY["lastSyncTimestamp"] = "a";
    USER_AGGREGATION_KEY["gamesPlayedTLSTS"] = "b";
    USER_AGGREGATION_KEY["liveGamesPlayed"] = "c";
    USER_AGGREGATION_KEY["totalGamesWonTLSTS"] = "d";
    USER_AGGREGATION_KEY["liveGamesWon"] = "e";
    USER_AGGREGATION_KEY["totalWinningsWonTLSTS"] = "f";
    USER_AGGREGATION_KEY["liveWithdrawalAmt"] = "g";
    USER_AGGREGATION_KEY["withdrawalCountTLSTS"] = "h";
    USER_AGGREGATION_KEY["liveWithdrawalCount"] = "i";
    USER_AGGREGATION_KEY["totalDepositedTLSTS"] = "j";
    USER_AGGREGATION_KEY["liveDepositedAmt"] = "k";
    USER_AGGREGATION_KEY["depositedCountTLSTS"] = "l";
    USER_AGGREGATION_KEY["liveWinnings"] = "m";
    USER_AGGREGATION_KEY["liveDepositedCount"] = "n";
    USER_AGGREGATION_KEY["streakTLSTS"] = "o";
    USER_AGGREGATION_KEY["liveStreak"] = "p";
    USER_AGGREGATION_KEY["globalBestStreakTLSTS"] = "q";
    USER_AGGREGATION_KEY["liveGlobalBestStreak"] = "r";
    USER_AGGREGATION_KEY["winLossSeqTLSTS"] = "s";
    USER_AGGREGATION_KEY["liveWinLossSeq"] = "t";
    USER_AGGREGATION_KEY["activeCRMComplaintsTLSTS"] = "u";
    USER_AGGREGATION_KEY["totalCRMComplaintsTLSTS"] = "v";
    USER_AGGREGATION_KEY["liveCRMComplaintsActive"] = "w";
    USER_AGGREGATION_KEY["liveCRMComplaintsTotal"] = "x";
    USER_AGGREGATION_KEY["liveRake"] = "y";
    USER_AGGREGATION_KEY["rakeTLSTS"] = "z";
    USER_AGGREGATION_KEY["userId"] = "aa";
    USER_AGGREGATION_KEY["eventTime"] = "ab";
    USER_AGGREGATION_KEY["totalWithdrawalTLSTS"] = "ac";
    USER_AGGREGATION_KEY["preferedEntryFeeTLSTS"] = "ad";
    USER_AGGREGATION_KEY["preferedEntryFee"] = "ae";
    USER_AGGREGATION_KEY["liveEntryFee"] = "af";
    USER_AGGREGATION_KEY["zupeeUserId"] = "ag";
    USER_AGGREGATION_KEY["signUpDate"] = "ah";
    USER_AGGREGATION_KEY["cashBackAmtTLSTS"] = "ai";
    USER_AGGREGATION_KEY["liveCashBackAmt"] = "aj";
    USER_AGGREGATION_KEY["gamesPwfPlayedTLSTS"] = "ak";
    USER_AGGREGATION_KEY["liveGamesPwfPlayed"] = "al";
    USER_AGGREGATION_KEY["totalPwfGamesWonTLSTS"] = "am";
    USER_AGGREGATION_KEY["livePwfGamesWon"] = "an";
    USER_AGGREGATION_KEY["totalPwfWinningsWonTLSTS"] = "ao";
    USER_AGGREGATION_KEY["livePwfWinnings"] = "ap";
    USER_AGGREGATION_KEY["totalTwoPlayerGamesWonTLSTS"] = "aq";
    USER_AGGREGATION_KEY["liveTwoPlayerGamesWon"] = "ar";
    USER_AGGREGATION_KEY["totalTwoPlayerGamesTLSTS"] = "as";
    USER_AGGREGATION_KEY["liveTwoPlayerGames"] = "at";
    USER_AGGREGATION_KEY["totalFourPlayerGamesWonTLSTS"] = "au";
    USER_AGGREGATION_KEY["liveFourPlayerGamesWon"] = "av";
    USER_AGGREGATION_KEY["totalFourPlayerGamesTLSTS"] = "aw";
    USER_AGGREGATION_KEY["liveFourPlayerGames"] = "ax";
})(USER_AGGREGATION_KEY = exports.USER_AGGREGATION_KEY || (exports.USER_AGGREGATION_KEY = {}));
var TOURNAMENT_NOT_JOINABLE_REASONS;
(function (TOURNAMENT_NOT_JOINABLE_REASONS) {
    TOURNAMENT_NOT_JOINABLE_REASONS["INVALID_REGISTRATION_STATUS"] = "You have already left the table";
    TOURNAMENT_NOT_JOINABLE_REASONS["WINNER_DECLARED"] = "Tournament has ended";
    TOURNAMENT_NOT_JOINABLE_REASONS["LEFT_NEW_TABLE"] = "You have already left the table";
    TOURNAMENT_NOT_JOINABLE_REASONS["SINGLE_PLAYER_ONLY"] = "Table not assigned, you will get the refund amount";
    TOURNAMENT_NOT_JOINABLE_REASONS["LEFT_TABLE"] = "You have already left the table";
    TOURNAMENT_NOT_JOINABLE_REASONS["PLAY_TABLE"] = "Table not assigned, you will get the refund amount";
    TOURNAMENT_NOT_JOINABLE_REASONS["MISC_ERROR"] = "Refund will be initiated for this game";
})(TOURNAMENT_NOT_JOINABLE_REASONS = exports.TOURNAMENT_NOT_JOINABLE_REASONS || (exports.TOURNAMENT_NOT_JOINABLE_REASONS = {}));
var USER_INVERSE_AGGREGATION_KEY;
(function (USER_INVERSE_AGGREGATION_KEY) {
    USER_INVERSE_AGGREGATION_KEY["a"] = "lastSyncTimestamp";
    USER_INVERSE_AGGREGATION_KEY["b"] = "gamesPlayedTLSTS";
    USER_INVERSE_AGGREGATION_KEY["c"] = "liveGamesPlayed";
    USER_INVERSE_AGGREGATION_KEY["d"] = "totalGamesWonTLSTS";
    USER_INVERSE_AGGREGATION_KEY["e"] = "liveGamesWon";
    USER_INVERSE_AGGREGATION_KEY["f"] = "totalWinningsWonTLSTS";
    USER_INVERSE_AGGREGATION_KEY["g"] = "liveWithdrawalAmt";
    USER_INVERSE_AGGREGATION_KEY["h"] = "withdrawalCountTLSTS";
    USER_INVERSE_AGGREGATION_KEY["i"] = "liveWithdrawalCount";
    USER_INVERSE_AGGREGATION_KEY["j"] = "totalDepositedTLSTS";
    USER_INVERSE_AGGREGATION_KEY["k"] = "liveDepositedAmt";
    USER_INVERSE_AGGREGATION_KEY["l"] = "depositedCountTLSTS";
    USER_INVERSE_AGGREGATION_KEY["m"] = "liveWinnings";
    USER_INVERSE_AGGREGATION_KEY["n"] = "liveDepositedCount";
    USER_INVERSE_AGGREGATION_KEY["o"] = "streakTLSTS";
    USER_INVERSE_AGGREGATION_KEY["p"] = "liveStreak";
    USER_INVERSE_AGGREGATION_KEY["q"] = "globalBestStreakTLSTS";
    USER_INVERSE_AGGREGATION_KEY["r"] = "liveGlobalBestStreak";
    USER_INVERSE_AGGREGATION_KEY["s"] = "winLossSeqTLSTS";
    USER_INVERSE_AGGREGATION_KEY["t"] = "liveWinLossSeq";
    USER_INVERSE_AGGREGATION_KEY["u"] = "activeCRMComplaintsTLSTS";
    USER_INVERSE_AGGREGATION_KEY["v"] = "totalCRMComplaintsTLSTS";
    USER_INVERSE_AGGREGATION_KEY["w"] = "liveCRMComplaintsActive";
    USER_INVERSE_AGGREGATION_KEY["x"] = "liveCRMComplaintsTotal";
    USER_INVERSE_AGGREGATION_KEY["y"] = "liveRake";
    USER_INVERSE_AGGREGATION_KEY["z"] = "rakeTLSTS";
    USER_INVERSE_AGGREGATION_KEY["aa"] = "userId";
    USER_INVERSE_AGGREGATION_KEY["ab"] = "eventTime";
    USER_INVERSE_AGGREGATION_KEY["ac"] = "totalWithdrawalTLSTS";
    USER_INVERSE_AGGREGATION_KEY["ad"] = "preferedEntryFeeTLSTS";
    USER_INVERSE_AGGREGATION_KEY["ae"] = "preferedEntryFee";
    USER_INVERSE_AGGREGATION_KEY["af"] = "liveEntryFee";
    USER_INVERSE_AGGREGATION_KEY["ag"] = "zupeeUserId";
    USER_INVERSE_AGGREGATION_KEY["ah"] = "signUpDate";
    USER_INVERSE_AGGREGATION_KEY["ai"] = "cashBackAmtTLSTS";
    USER_INVERSE_AGGREGATION_KEY["aj"] = "liveCashBackAmt";
    USER_INVERSE_AGGREGATION_KEY["ak"] = "gamesPwfPlayedTLSTS";
    USER_INVERSE_AGGREGATION_KEY["al"] = "liveGamesPwfPlayed";
    USER_INVERSE_AGGREGATION_KEY["am"] = "totalPwfGamesWonTLSTS";
    USER_INVERSE_AGGREGATION_KEY["an"] = "livePwfGamesWon";
    USER_INVERSE_AGGREGATION_KEY["ao"] = "totalPwfWinningsWonTLSTS";
    USER_INVERSE_AGGREGATION_KEY["ap"] = "livePwfWinnings";
    USER_INVERSE_AGGREGATION_KEY["aq"] = "totalTwoPlayerGamesWonTLSTS";
    USER_INVERSE_AGGREGATION_KEY["ar"] = "liveTwoPlayerGamesWon";
    USER_INVERSE_AGGREGATION_KEY["as"] = "totalTwoPlayerGamesTLSTS";
    USER_INVERSE_AGGREGATION_KEY["at"] = "liveTwoPlayerGames";
    USER_INVERSE_AGGREGATION_KEY["au"] = "totalFourPlayerGamesWonTLSTS";
    USER_INVERSE_AGGREGATION_KEY["av"] = "liveFourPlayerGamesWon";
    USER_INVERSE_AGGREGATION_KEY["aw"] = "totalFourPlayerGamesTLSTS";
    USER_INVERSE_AGGREGATION_KEY["ax"] = "liveFourPlayerGames";
})(USER_INVERSE_AGGREGATION_KEY = exports.USER_INVERSE_AGGREGATION_KEY || (exports.USER_INVERSE_AGGREGATION_KEY = {}));
exports.liveGamesFields = ['liveGamesPlayed', 'liveGamesWon', 'liveDepositedAmt', 'liveWithdrawalAmt', 'liveDepositedCount',
    'liveWithdrawalCount', 'liveRake', 'liveWinnings', 'liveCRMComplaintsTotal', 'liveCRMComplaintsActive', 'liveCashBackAmt',
    'liveGamesPwfPlayed', 'livePwfGamesWon', 'livePwfWinnings', 'liveTwoPlayerGamesWon', 'liveTwoPlayerGames', 'liveFourPlayerGamesWon', 'liveFourPlayerGames',
];
var SIGN_IN_SIGN_UP;
(function (SIGN_IN_SIGN_UP) {
    SIGN_IN_SIGN_UP["SIGN_IN"] = "SIGN_IN";
    SIGN_IN_SIGN_UP["SIGN_UP"] = "SIGN_UP";
})(SIGN_IN_SIGN_UP = exports.SIGN_IN_SIGN_UP || (exports.SIGN_IN_SIGN_UP = {}));
var consumerType;
(function (consumerType) {
    consumerType["MAKE_CREDIT_TRANSACTIONS_NOTIFICATION"] = "make_credit_transactions_notification";
    consumerType["PAYMENT_COMPLETE"] = "payment_complete";
    consumerType["PROFILE_UPDATE_POST_KYC"] = "profile_update_post_kyc";
})(consumerType = exports.consumerType || (exports.consumerType = {}));
var INTERNAL_DASHBOARDS;
(function (INTERNAL_DASHBOARDS) {
    INTERNAL_DASHBOARDS["CRM"] = "crm";
    INTERNAL_DASHBOARDS["MARKETING"] = "marketing";
})(INTERNAL_DASHBOARDS = exports.INTERNAL_DASHBOARDS || (exports.INTERNAL_DASHBOARDS = {}));
var MARKETING_DASHBOARD_CSV_TYPES;
(function (MARKETING_DASHBOARD_CSV_TYPES) {
    MARKETING_DASHBOARD_CSV_TYPES["CREDIT_COINS_BY_ADMIN"] = "creditCoinsByAdmin";
    MARKETING_DASHBOARD_CSV_TYPES["BULK_REFUND_BY_ADMIN"] = "bulkRefundByAdmin";
})(MARKETING_DASHBOARD_CSV_TYPES = exports.MARKETING_DASHBOARD_CSV_TYPES || (exports.MARKETING_DASHBOARD_CSV_TYPES = {}));
//# sourceMappingURL=common.js.map